import nanobus from 'nanobus'
export const bus = nanobus()